import React from 'react'
import { styled } from '@creditas/stylitas'
import { Footer, FooterGroup } from '@creditas/footer'
import { Typography } from '@creditas/typography'
import { ActionLink } from '@creditas/button'

const StyledFooter = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
`

const AppFooter = () => (
  <StyledFooter>
    <Footer variant="internal">
      <FooterGroup>
        <Typography variant="support">
          Creditas 2019. Todos direitos reservados.
        </Typography>
      </FooterGroup>
      <FooterGroup>
        <ActionLink href="#">Problemas no MDO? Reporte aqui.</ActionLink>
      </FooterGroup>
    </Footer>
  </StyledFooter>
)

export { AppFooter as Footer }
